import React from "react";
import { aboutText, aboutImages } from "../data/mock";

export default function About() {
  return (
    <section id="about" className="py-24 md:py-36 relative">
      <div className="max-w-[1300px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
          <div className="md:col-span-5 fade-in img-hover">
            <div className="aspect-[4/5] overflow-hidden">
              <img src={aboutImages.chef} alt="Chef in the kitchen at Mamamina's" className="w-full h-full object-cover" />
            </div>
          </div>

          <div className="md:col-span-7 md:pl-8 fade-in">
            <div className="section-label mb-6">Our Story</div>
            <h2 className="font-display text-5xl md:text-7xl leading-[0.95] text-[var(--mm-cream)] mb-8 italic font-light">
              Cooked with fire.<br />
              <span className="text-[var(--mm-accent)]">Served with soul.</span>
            </h2>
            <p className="text-lg text-[var(--mm-cream-muted)] leading-relaxed max-w-xl font-light">
              {aboutText}
            </p>
            <div className="mt-10 flex flex-wrap gap-8">
              <div>
                <div className="font-display text-4xl text-[var(--mm-accent)]">4.9★</div>
                <div className="text-xs tracking-[0.24em] uppercase text-[var(--mm-cream-muted)] mt-1">Google Rating</div>
              </div>
              <div>
                <div className="font-display text-4xl text-[var(--mm-accent)]">158+</div>
                <div className="text-xs tracking-[0.24em] uppercase text-[var(--mm-cream-muted)] mt-1">5-Star Reviews</div>
              </div>
              <div>
                <div className="font-display text-4xl text-[var(--mm-accent)]">100%</div>
                <div className="text-xs tracking-[0.24em] uppercase text-[var(--mm-cream-muted)] mt-1">Halal</div>
              </div>
            </div>
          </div>
        </div>

        {/* Second row spread image */}
        <div className="mt-24 fade-in img-hover">
          <div className="aspect-[16/7] overflow-hidden">
            <img src={aboutImages.spread} alt="Table spread of shareable dishes" className="w-full h-full object-cover" />
          </div>
        </div>
      </div>
    </section>
  );
}
